import React, { useState } from 'react';
import { formatDateWithTime } from 'utils/other';
import { numberWithCommas, getInfluenceName } from 'utils/other';
import { Button } from 'reactstrap';
import './style.scss';

export default function Preview({ feed, sourceType, ...props }) {
    const [showBtn, setMode] = useState(false);

    const toTop = (e) => {
        if (e.nativeEvent.target.tagName === 'I') {
            return (e.nativeEvent.target.parentElement.parentElement.scrollTop = 0);
        }
        e.nativeEvent.target.parentElement.scrollTop = 0;
    };

    const handleCheckScroll = (e) => {
        const scrollCoordinates = e.nativeEvent.target.scrollTop;
        if (scrollCoordinates > 300) {
            setMode(true);
        } else {
            setMode(false);
        }
    };

    return (
        <div className="preview-list-container" onScroll={(e) => handleCheckScroll(e)}>
            {feed.length ? (
                feed.map((news, index) => (
                    <div className="mb-3 mt-1 news" key={index}>
                        <a 
                            style={{ fontSize: '16px', textDecoration: 'none', fontWeight: '700' }} 
                            className="news_link" 
                            target="blank" 
                            href={news.url}
                        >
                            {news.shortTitle}
                        </a>
                        {news.publishedAt && (
                            <React.Fragment>
                                <br />
                                {news.domain &&
                                    <span style={{ color: '#869fac', fontSize: '13px' }}>
                                        {news.domain + ' • '}
                                    </span>
                                }
                                <span style={{ color: '#869fac', fontSize: '13px' }}>
                                    {formatDateWithTime(news.publishedAt)}
                                </span>
                            </React.Fragment>
                        )}
                        {news.authorScreenName && (
                            <a 
                                target="_blank"
                                rel="noopener noreferrer"
                                href={news.authorUrl} 
                                style={{ color: '#869fac', fontSize: '13px', textDecoration: 'underline', paddingLeft: '5px' }}
                            >
                                {news.authorScreenName}
                            </a>
                        )}
                        {news.influence && (
                            <span style={{ color: '#869fac', fontSize: '13px' }}>
                                &nbsp;{`(${numberWithCommas(news.influence)} ${getInfluenceName(sourceType)})`}
                            </span>
                        )}
                        {news.shortAbstract && (
                            <React.Fragment>
                                <br />
                                <span style={{ fontSize: '1rem' }}>{news.shortAbstract}</span>
                            </React.Fragment>
                        )}
                    </div>
                ))
            ) : (
                <div style={{ fontWeight: '700' }}>No results found</div>
            )}
            {showBtn && (
                <Button onClick={(e) => toTop(e)} style={{ color: 'white', marginRight: 20 }} className="btnBackToTop">
                    <i className="fas fa-arrow-up" />
                </Button>
            )}
        </div>
    );
}
